<template>
    <div>
        <div class="sort-select pt-lg">
            <h1 class="h4 palm-mb-sm">Committees</h1>
            <div class="sort-select__wrapper">
                <span class="text--grey-light mr-sm">Sort by</span>
                <v-select
                    :value="sortBy"
                    :clearable="false"
                    :searchable="false"
                    :options="['membership', 'type']"
                    :get-option-label="capitalizeLabel"
                    @input="setSort"
                />
            </div>
        </div>
        <div v-for="(section, index) in sortedSection" :key="index" class="committees-list mb-xl">
            <div v-if="section.committees.length">
                <div class="committees-list__heading mb-lg">
                    <h3 class="semi">{{ section.title }}</h3>
                    <Tooltip v-if="section.tooltip" :text="section.tooltip" />
                </div>
                <div class="committees-list__section">
                    <committee-card
                        v-for="committee in section.committees"
                        :key="committee.id"
                        :committees="committee.committees"
                        :membership-level="committee.membershipLevel"
                        :title="committee.title"
                        :url="committee.url"
                        :current-user="currentUser"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { capitalize } from 'lodash';
import CommitteeCard from '@/committees/CommitteeCard';
import Tooltip from '@/components/Tooltip';
export default {
    name: "CommitteesList",
    components: {
       CommitteeCard,
       Tooltip
    },
    props: {
     currentUser: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            committees: [],
            sortBy: 'membership'
        };
    },
    computed: {
        type () {
            let types = {};
            this.committees.forEach(committee => {
                const committeeType = committee.type;
                const typeId = `_${committeeType.id}`;
                if (!types[typeId]) {
                    types[typeId] = {
                        id: committeeType.id,
                        title: committeeType.title,
                        tooltip:  committeeType.tooltip,
                        committees: []
                    }
                }
                types[typeId].committees.push(committee);
            });

            types = Object.values(types);

            types.sort((a, b) => a.title.localeCompare(b.title));


            return types;
        },
        membership () {
            const membership = {
                member: {
                    title: 'My Committees',
                    tooltip:  'These are the Committees you are currently participating in.',
                    committees: []
                },
                nonMember: {
                    title: 'Available Committees',
                    tooltip: 'These committees are open to you based on your membership level. Contact our membership team to join.',
                    committees: []
                },
                restricted: {
                    title: 'Restricted Committees',
                    tooltip: 'Participation in these committees is restricted by membership level, or invitation. Contact our membership team for further details.',
                    committees: []
                },
            };
            this.committees.forEach(committee => {
                if (this.isMember(committee)) {
                    membership.member.committees.push(committee);
                } else {
                    if (this.isAvailable(committee)) {
                        membership.nonMember.committees.push(committee);
                    } else {
                        membership.restricted.committees.push(committee);
                    }
                }
            });
            return Object.values(membership);
        },
        sortedSection() {
            let sections = [];
            switch (this.sortBy) {
                case 'type':
                    sections = this.type;
                    break;
                case 'membership':
                    sections = this.membership;
                    break;
            }
            return sections;
        }
    },
    beforeMount() {
        // Fetch
        axios.get('/api/committees.json')
            .then((response) => {
                this.committees = response.data.data;
            });
    },
    methods: {
        setSort(method) {
            this.sortBy = method;
        },
        capitalizeLabel(option) {
            return capitalize(option);
        },
        isMember (committee) {
            return !!this.currentUser.committees.filter(element => committee.committees.indexOf(element) !== -1).length;
        },
        isAvailable (committee) {
            if (this.isMember(committee)) {
                return true;
            } else {
                if (committee.membershipLevel.length && this.currentUser.membershipLevel.length) {
                    return this.currentUser.membershipLevel.filter(element => committee.membershipLevel.indexOf(element) !== -1).length;
                }
                return false;
            }
        }
    },
};
</script>

<style lang="scss" scoped>
    .tool {
        margin-left: 0.5em;

        &::v-deep .tool-icon {
            background-color: #AFAFAF;
        }
    }
</style>
